(function () {
  function injectBadges () {
    if (!window.lfTagMap) return;
    var cards = document.querySelectorAll('product-card[data-product-id]');
    
    cards.forEach(function (card) {
      var pid = card.getAttribute('data-product-id');
      if (!pid) return;
      
      var rawTags = window.lfTagMap[pid];
      if (!rawTags || !Array.isArray(rawTags)) return;
      
      var tags = rawTags.map(function(t) { return t.toLowerCase().trim(); });
      var badgeContainer = card.querySelector('.product-badges');
      if (!badgeContainer) return;

      // Limpiar inyecciones previas
      card.querySelectorAll('.lf-badge-nuevo, .lf-badge-preorder').forEach(el => el.remove());

      /* Inyectamos Preorder */
      if (tags.indexOf('preorder') !== -1 || tags.indexOf('pre-order') !== -1) {
        var bPre = document.createElement('div');
        bPre.className = 'product-badges__badge lf-badge-preorder';
        bPre.textContent = 'PREORDER';
        badgeContainer.prepend(bPre);
      }

      /* Inyectamos Nuevo */
      if (tags.indexOf('nuevo') !== -1 || tags.indexOf('new') !== -1) {
        var bNew = document.createElement('div');
        bNew.className = 'product-badges__badge lf-badge-nuevo';
        bNew.textContent = 'NUEVO';
        badgeContainer.appendChild(bNew);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectBadges);
  } else {
    injectBadges();
  }
  document.addEventListener('shopify:section:load', injectBadges);
  
  var _pushState = history.pushState;
  history.pushState = function () {
    _pushState.apply(history, arguments);
    setTimeout(injectBadges, 500);
  };
})();
